import _ from 'lodash';


const analyticsTypes = {
  BIO_MATRIX_BANNER_SHOW: 'biomatrix_Banner_Show',
  BIO_MATRIX_OPEN: 'biomatrix_Open',
  BIO_MATRIX_CLOSE: 'biomatrix_Close',
  BIO_MATRIX_SUBMIT: 'biomatrix_Submit',
};

const extractBiomatrixClose = timeOpened => ({
  secondsSpent: _.round((Date.now() - timeOpened) / 1000),
});

const dollarKeys = [
  'subtotal',
  'savings',
  'syringeSavings',
  'totalSavings',
];

const extractDollars = summary => (
  _.reduce(dollarKeys, (acc, key) => ({ ...acc, [`${key}Dollars`]: _.get(summary, key, 0) / 100 }), {})
);

const extractBiomatrixSubmit = summary => ({
  ...summary,
  ...extractDollars(summary),
});

const analyticsActions = [{
  type: analyticsTypes.BIO_MATRIX_BANNER_SHOW,
}, {
  type: analyticsTypes.BIO_MATRIX_OPEN,
}, {
  type: analyticsTypes.BIO_MATRIX_CLOSE,
  attributesExtractor: extractBiomatrixClose,
}, {
  type: analyticsTypes.BIO_MATRIX_SUBMIT,
  attributesExtractor: extractBiomatrixSubmit,
}];

export {
  analyticsTypes,
  analyticsActions,
};
